import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Router } from 'express';
import { LoadingService } from '../loading/loading.service';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarriertoserviceofferingService extends DataService {
  private selectURI = this.apiUri + '/carriertoserviceofferings';
  constructor(protected http: HttpClient, private loader: LoadingService) {
    super(http);
  }

  getServiceOfferingOnCarrierID(carrierId: Number): Observable<any> {
      const iffRatesUrl = this.selectURI + '/'+ carrierId + "/carrierid";
      return this.http.get<any>(iffRatesUrl).pipe(catchError(this.handleError));
    }
}
